import { Button } from "@mui/material";
import { BigNumber } from "ethers";
import { useClaim } from "modules/bridge/hooks/useClaim";
import { Address } from "viem";
import { useChainId, useSwitchChain } from "wagmi";
import { mainnet } from "wagmi/chains";

interface Props {
  amount: BigNumber;
  depositCount: number;
  depositTxHash: string;
  destinationAddress: Address;
  from: { networkId: number; bridgeContractAddress: Address };
  globalIndex: number;
  to: { key: string; networkId: number; bridgeContractAddress: Address };
  token: { address: Address; chainId: number };
  tokenOriginNetwork: number;
}

export const ClaimButton = ({
  amount,
  depositCount,
  depositTxHash,
  destinationAddress,
  from,
  globalIndex,
  to,
  token,
  tokenOriginNetwork,
}: Props) => {
  const { switchChainAsync } = useSwitchChain();

  const chainId = useChainId();
  const { claim } = useClaim({
    bridge: {
      amount,
      depositCount,
      depositTxHash,
      destinationAddress,
      from,
      globalIndex,
      to,
      token,
      tokenOriginNetwork,
    },
  });

  const handleClaim = async () => {
    if (chainId === mainnet.id) {
      await claim();
    } else {
      await switchChainAsync({ chainId: mainnet.id });
      await claim();
    }
  };

  return (
    <Button
      onClick={handleClaim}
      sx={{
        minWidth: "fit-content",
      }}
      variant="contained"
      color="primary"
    >
      {chainId !== mainnet.id ? "Change Network" : "Claim"}
    </Button>
  );
};
